import { useEffect, useState } from "react"
import { Check, Copy, Eye, EyeOff, RefreshCw, Search, UserPlus, Clock } from 'lucide-react'
import { useSelector } from "react-redux";
import { addUserByCompanyAdmin, getOrgPartners } from "../../API/Company-admin/userApi";
import { toast } from "react-toastify";

export default function AccountCreation() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const token = userInfo.token

  const [showAlert, setShowAlert] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [password, setPassword] = useState("Temp#Pass123")
  const [sendInvitation, setSendInvitation] = useState(true)
  const [showLogs, setShowLogs] = useState(false)
  const [partners, setPartners] = useState([]);

  const handleCreateAccount = async (e) => {
    e.preventDefault()

    const form = document.getElementById("account-form");
    const data = new FormData(form);

    const payload = {
      organisationId:userInfo?.organisation_id,
      firstName: data.get("first-name"),
      lastName: data.get("last-name"),
      email: data.get("email"),
      role: data.get("role"),
      team: data.get("team"),
      partner_name: data.get("partner"),
      password: password,
      sendInvitation: sendInvitation,
    };

    // setShowAlert(true)
    // setTimeout(() => setShowAlert(false), 3000)
    try {
        await addUserByCompanyAdmin(payload, token);
        toast.success('User created successfully');
        form.reset();

        // Also reset states if needed
        setPassword("");
        setSendInvitation(false);
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to create user');
      } finally {
        // setLoading(false);
      }
  }


  const getPartners = async () => {
    try {
      const response = await getOrgPartners(userInfo?.organisation_id, token);
      setPartners(response.partner_names);
    } catch (error) {
      console.error("Error fetching partners: ", error);
    }
  }

  useEffect(()=>{
    getPartners();
  },[])

  const generatePassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*"
    let newPassword = ""
    for (let i = 0; i < 12; i++) {
      newPassword += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    setPassword(newPassword)
  }

  const copyPassword = () => {
    navigator.clipboard.writeText(password)
  }

  const recentAccounts = [
    {
      id: "acc1",
      name: "John Smith",
      email: "john.smith@company.com",
      role: "Editor",
      status: "Active",
      created: "2023-04-01",
    },
    {
      id: "acc2",
      name: "Lisa Wong",
      email: "lisa.wong@company.com",
      role: "Admin",
      status: "Pending",
      created: "2023-03-28",
    },
    {
      id: "acc3",
      name: "Robert Johnson",
      email: "robert.j@company.com",
      role: "Viewer",
      status: "Active",
      created: "2023-03-25",
    },
  ]

  const recentLogs = [
    { id: "log1", action: "Login", timestamp: "2023-04-07 09:15:22", ip: "192.168.1.1" },
    { id: "log2", action: "Password Changed", timestamp: "2023-04-05 14:30:45", ip: "192.168.1.1" },
    { id: "log3", action: "Profile Updated", timestamp: "2023-04-03 11:22:10", ip: "192.168.1.1" },
    { id: "log4", action: "Document Downloaded", timestamp: "2023-04-01 16:45:33", ip: "192.168.1.1" },
  ]

  return (
    <div className="grid gap-6 md:grid-cols-2">
      {showAlert && (
        <div className="col-span-full rounded-lg bg-green-50 p-4 text-green-800">
          <div className="flex">
            <div className="flex-shrink-0">
              <Check className="h-5 w-5" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium">Success</h3>
              <div className="mt-2 text-sm">
                Account has been created successfully. An invitation email has been sent.
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-900">Create New Account</h3>
          <p className="text-sm text-gray-500">Manually create a new user account</p>
        </div>
        <div className="px-6 py-4">
          <form className="space-y-4" id="account-form">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                  First Name
                </label>
                <input
                  name="first-name"
                  type="text"
                  placeholder="Enter first name"
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                  Last Name
                </label>
                <input
                  type="text"
                  name="last-name"
                  placeholder="Enter last name"
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="role" className="block text-sm font-medium text-gray-700">
                Role
              </label>
              <select
                className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                defaultValue="employee"
                name="role"
              >
                <option value="admin">Admin</option>
                <option value="employee">Member</option>
              </select>
            </div>

            <div className="space-y-2">
              <label htmlFor="partner" className="block text-sm font-medium text-gray-700">
                Assign to Partner
              </label>
              <select
                name="partner"
                className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
              >
                <option value="">Select Partner</option>
                {partners?.map((partner, index) => (
                  <option key={index} value={partner}>{partner}</option>
                ))}
              </select>
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Temporary Password
                </label>
                <button
                  type="button"
                  className="text-xs font-medium text-gray-700 hover:text-gray-500"
                  onClick={generatePassword}
                >
                  <div className="flex items-center">
                    <RefreshCw className="mr-1 h-3 w-3" />
                    Generate
                  </div>
                </button>
              </div>
              <div className="flex">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1 block w-full rounded-l-md border border-r-0 border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                />
                <button
                  type="button"
                  className="inline-flex items-center rounded-none border border-gray-300 bg-gray-50 px-3 py-2"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
                <button
                  type="button"
                  className="inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 py-2"
                  onClick={copyPassword}
                >
                  <Copy className="h-4 w-4" />
                </button>
              </div>
            </div>

            {/* <div className="flex items-center space-x-2">
              <div className="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
                <span className="sr-only">Send invitation email</span>
                <span
                  aria-hidden="true"
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                    sendInvitation ? "translate-x-5" : "translate-x-0"
                  }`}
                  onClick={() => setSendInvitation(!sendInvitation)}
                />
              </div>
              <span className="text-sm font-medium text-gray-900">Send invitation email</span>
            </div> */}
          </form>
        </div>
        <div className="border-t border-gray-200 px-6 py-4">
          <button
            onClick={handleCreateAccount}
            className="inline-flex items-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700"
          >
            <UserPlus className="mr-2 h-4 w-4" />
            Create Account
          </button>
        </div>
      </div>

      {/* <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">Recently Created Accounts</h3>
            <button
              onClick={() => setShowLogs(!showLogs)}
              className="flex items-center text-sm font-medium text-gray-600 hover:text-red-600"
            >
              {showLogs ? "Show Accounts" : "Show Logs"}
              <Clock className="ml-1 h-4 w-4" />
            </button>
          </div>
          <p className="text-sm text-gray-500">
            {showLogs ? "View recent account activity logs" : "View recently created user accounts"}
          </p>
        </div>
        <div className="px-6 py-4">
          <div className="mb-4 relative">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <Search className="h-4 w-4 text-gray-500" />
            </div>
            <input
              type="text"
              placeholder={showLogs ? "Search logs..." : "Search accounts..."}
              className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {!showLogs ? (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      Role
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      Created
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {recentAccounts
                    .filter(
                      (account) =>
                        account.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        account.email.toLowerCase().includes(searchTerm.toLowerCase()),
                    )
                    .map((account) => (
                      <tr key={account.id}>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                          <div>
                            <div className="font-medium">{account.name}</div>
                            <div className="text-sm text-gray-500">{account.email}</div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{account.role}</td>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                          <span
                            className={`inline-flex rounded-full ${account.status === "Active" ? "bg-green-600" : "bg-amber-600"} px-2 text-xs font-semibold leading-5 text-white`}
                          >
                            {account.status}
                          </span>
                        </td>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{account.created}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      Action
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      Timestamp
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      IP Address
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {recentLogs
                    .filter((log) => log.action.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((log) => (
                      <tr key={log.id}>
                        <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">{log.action}</td>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500 font-mono">{log.timestamp}</td>
                        <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500 font-mono">{log.ip}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div> */}
    </div>
  )
}

